export default "__VITE_ASSET__BJMXN73F__"